var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserImport = function SvgUserImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 22-3 2 13 12 13-12-3-2-8 9V6h-3v25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6v3h9v30H9V9h9V6H6v36h36V6z"
  })));
};
export default SvgUserImport;